export default {
  methods: {
    /// REGIÕES

    /**
     * Deixa todas as regiões inativas
     * ex: Se o usuário clicar na região 'Sudeste' no mapa
     * vai inativar as regiões 'Norte', 'Nordeste', 'Centro-Oeste' e 'Sul'
     */
    marcarRegiao() {
      let pointsRegiao = this.$refs.mapa.chart.series[1].points;

      pointsRegiao.forEach(e => {
        if (e.properties.sigla !== this.regiaoClicada) {
          e.setState("inactive");
        }
      });
    },
    /**
     * Reseta o estado de todas as regiões
     */
    desmarcarRegiao() {
      let pointsRegiao = this.$refs.mapa.chart.series[1].points;
      pointsRegiao.forEach(e => {
        e.setState("");
      });
    },
    /**
     * Função que é chamada quando o mouse está sobre
     * alguma região
     */
    mouseOverRegiao(ev) {
      let sigla = ev.target.properties.sigla;

      this.marcarEstadoRegiao(sigla);
    },
    /**
     * Função que é chamada quando o mouse sai de alguma região.
     */
    mouseOutRegiao() {
      this.desmarcarEstadoRegiao();
    },
    /**
     * Marca os estado de alguma região, pela sigla.
     * Se alguma outra região estiver selecionada, essa função
     * não irá se chamada
     */
    marcarEstadoRegiao(sigla) {
      if (this.regiaoClicada !== null || this.estadoMarcado) return;

      this.estadosHover = [];
      this.estadosSemHover = [];

      let pointsEstado = this.$refs.mapa.chart.series[0].points;

      pointsEstado.forEach(e => {
        if (e.properties.regiao.sigla === sigla) {
          e.setState("hover");
          this.estadosHover.push(e);
        } else {
          e.setState("inactive");
          this.estadosSemHover.push(e);
        }
      });

      this.regiaoMarcada = true;
    },
    /**
     * Desmarca todos os estados, deixando todos com o estado inicial.
     * Se alguma outra região estiver selecionada, essa função
     * não irá se chamada
     */
    desmarcarEstadoRegiao() {
      if (this.regiaoClicada !== null || this.estadoMarcado) return;

      this.estadosHover.forEach(e => {
        e.setState("");
      });
      this.estadosSemHover.forEach(e1 => {
        e1.setState("");
      });

      this.regiaoMarcada = false;
    },
    /**
     * Inicia as legendas com as regiões
     */
    adicionarLegendaRegiao() {
      this.dataRegioes.forEach((e, i) => {
        const objetoRegiao = {
          ...e,
          color: this.cores[i],
          grouping: false,
          events: {
            legendItemClick: ev => this.cliqueLegendaRegiao(ev)
          },
          data: [
            {
              sigla: e.sigla,
              value: e.value,
              name: e.name
            }
          ],
          legendIndex: i,
          id: e.sigla
        };
        this.graficoRef.addSeries(objetoRegiao);
      });
    },
    /**
     * Ação de clique da legenda
     * @param { Event } ev
     */
    cliqueLegendaRegiao(ev) {
      const siglaLegenda = ev.target.data[0].sigla;
      if (this.regiaoClicada !== null && this.regiaoClicada !== siglaLegenda)
        return ev.preventDefault();

      const point = this.graficoRef.series[1].points.find(
        e => e.properties.sigla === siglaLegenda
      );

      this.clickRegiao(point);

      ev.preventDefault();
    },

    /**
     * @param { Object } point
     * @param { Boolean } isClickMapa - Se foi clicado pelo mapa
     * Função que é chamada quando houver algum click em alguma região
     */
    clickRegiao(point, isClickMapa = false) {
      if (this.estadoMarcado) return;

      let siglaAtual = point.properties.sigla;

      if (this.regiaoClicada !== null && this.regiaoClicada === siglaAtual) {
        this.$emit("remove-filtro", {
          chaveRemocao: "regiao",
          sucesso: () => this.ativarDadosRegiao(point, isClickMapa)
        });
        return;
      } else if (this.regiaoClicada !== null) return;

      this.$emit("adiciona-filtro", {
        chaveAdicao: "regiao",
        value: siglaAtual,
        sucesso: () => this.desativarDadosRegiao(point)
      });
    },
    /**
     * @param { Object } point
     * Salva a região clicada, inativa as demais regiões, fixa
     * o tooltip na região e "desativa" o tooltip de sumir ou mudar de posição
     */
    desativarDadosRegiao(point) {
      const { sigla } = point.options;

      this.marcarEstadoRegiao(sigla);

      this.regiaoClicada = sigla;

      this.marcarRegiao();
      this.desativarLegendaRegioes();

      this.graficoRef.tooltip.refresh(point);

      this.desativarTooltip();
    },

    /**
     * @param { Object } point
     * * @param { Boolean } isClickMapa - Se foi clicado pelo mapa
     * Desfoca da região, anteriomente selecionada e reativa o tooltip
     */
    ativarDadosRegiao(point, isClickMapa) {
      this.regiaoClicada = null;

      this.desmarcarEstadoRegiao();
      this.desmarcarRegiao();

      this.ativarLegendaRegioes();

      this.ativarTooltip();
      this.graficoRef.tooltip.refresh(point);

      if (!isClickMapa) {
        this.esconderTooltip();
      }

      this.isLegendaClickada = false;
    }
  }
};
